import { DOCUMENT } from '@angular/common';
import { Injectable, effect, inject } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { Translation } from 'primeng/api';
import { ClaveAlmacenamiento } from '@nucleo/modelos/clave-almacenamiento.enum';
import { TRADUCCION_PRIMENG_ES } from '@nucleo/tema/traduccion-primeng-es';
import { TRADUCCION_PRIMENG_EN } from '@nucleo/tema/traduccion-primeng-en';
import { Idioma } from './idioma.enum';
import { establecerIdiomaActivo, idiomaActual } from './idioma-actual';

const TRADUCCION_PRIMENG: Record<Idioma, Translation> = {
  [Idioma.ESPANOL]: TRADUCCION_PRIMENG_ES,
  [Idioma.INGLES]: TRADUCCION_PRIMENG_EN,
};

/**
 * Cambia el idioma de toda la aplicación en caliente: textos propios (vía `traducciones()`), PrimeNG (calendario,
 * paginador) y `<html lang>`. Lo guarda en el navegador; guardarlo en el usuario del backend lo hace
 * `SesionApiServicio.cambiarIdioma` (este servicio no hace HTTP para que el login pueda usarlo sin sesión).
 * `PrimeNG` se usa aquí porque es configuración transversal (como `providePrimeNG`), no UI.
 */
@Injectable({ providedIn: 'root' })
export class IdiomaServicio {
  private readonly primeng = inject(PrimeNG);
  private readonly documento = inject(DOCUMENT);

  readonly idioma = idiomaActual;

  constructor() {
    effect(() => {
      const idioma = idiomaActual();
      this.primeng.setTranslation(TRADUCCION_PRIMENG[idioma]);
      this.documento.documentElement.lang = idioma;
    });
  }

  cambiar(idioma: Idioma): void {
    establecerIdiomaActivo(idioma);
    try {
      localStorage.setItem(ClaveAlmacenamiento.IDIOMA, idioma);
    } catch {
      // Sin acceso a localStorage: el cambio vale solo para esta pestaña.
    }
  }
}
